"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseCard_1 = require("./BaseCard");
exports.default = BaseCard_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/BaseCard/index.js
// module id = 940
// module chunks = 8